import { render, staticRenderFns } from "./SearchLead.vue?vue&type=template&id=2513c588&lang=true"
import script from "./SearchLead.vue?vue&type=script&lang=js"
export * from "./SearchLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports